export const FILTERS_MODE_PRIMARY = 'primary';
export const FILTERS_MODE_GENERAL = 'general';
